export const FORUM_HOME = "/forum";
export const FORUM_POST_DETAIL = `${FORUM_HOME}/post/:postId`;
export const NATIVE_FORUM_HOME = "Forum";
export const NATIVE_FORUM_POST_DETAIL = "PostDetail";

export const linkTo = {
  forum: () => FORUM_HOME,
  forumPostDetail: id => FORUM_POST_DETAIL.replace(":postId", id),
};
